import { styled, Typography } from '@mui/material';

// export const SubtitleContainer = styled(Box)<BoxProps & { bgColor: string }>(({ bgColor }) => ({
//     bgcolor: bgColor,
//     borderRadius: '8px',
//     mt: '4px',
//     py: 1.5,
//     px: 2,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
// }));

export const SnackbarTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.neutralDarkGrey.main,
    fontSize: '20px',
    fontWeight: 500,
    margin: 0,
    letterSpacing: '0.15px',
    lineHeight: '32px'
}));

export const SnackbarSubtitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.neutralWhite.main,
    fontSize: '14px',
    fontWeight: 500
}));

export const CountdownMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette.neutralDarkGrey.main,
    fontSize: '12px',
    fontWeight: 300,
    textAlign: 'center',
    lineHeight: '166%',
    letterSpacing: '0.4px'
}));
